import { render } from "./StorefrontOrderDetail.vue?vue&type=template&id=5cc9d000"
import script from "./StorefrontOrderDetail.vue?vue&type=script&lang=js"
export * from "./StorefrontOrderDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__